import { render, staticRenderFns } from "./OpinionSurveyManagment.vue?vue&type=template&id=c07a446e&scoped=true&"
import script from "./OpinionSurveyManagment.vue?vue&type=script&lang=js&"
export * from "./OpinionSurveyManagment.vue?vue&type=script&lang=js&"
import style0 from "./OpinionSurveyManagment.vue?vue&type=style&index=0&id=c07a446e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07a446e",
  null
  
)

export default component.exports